const getProductType = (product: any): string => {
    switch (product.productType) {
        case 'comprehensivePensionFund':
            return 'פנסיה מקיפה';
        case 'complementaryPensionFund':
            return 'פנסיה משלימה'
        case 'directorsInsurance':
            return 'ביטוח מנהלים'
        case 'studyFund':
            return 'קרן השתלמות';
        case 'providentFund':
            return 'קופת גמל';
        case 'investmentFund':
            return 'גמל להשקעה'
        case 'carInsurance':
            return 'ביטוח רכב';
        case 'homeInsurance':
            return 'ביטוח דירה';
        case 'healthInsurance':
            return 'ביטוח בריאות';
        case 'lifeInsurance':
            return 'ביטוח חיים';
        case 'workDisability':
            return 'אובדן כושר עבודה';
        case 'longTermCare':
            return 'ביטוח סיעודי';
        default:
            return ''
    }
}


const getCompanyName = (product: any): string => {
    if (!product) return '';
    const words = [
        'קרנות',
        'גמל ופנסיה',
        'פנסיה וגמל',
        'קופות גמל',
        'השתלמות',
        'חברה לבטוח',
        'חברה לביטוח',
        'פנסיה',
        'מבטחים',
        'גמל',
        'ניהול',
        'בע"מ',
        'שחם',
        'מקפת',
        'קופ"ג'
    ]

    let companyName = product.companyName;
    
    // Handle case where companyName is undefined or null
    if (!companyName) {
        return '';
    }
    
    for (const word of words) {
        if (companyName.includes(word)){
            const splits = companyName.split(word);
            if (splits.length > 1) {
                if (splits[0].trim()) {
                    companyName = splits[0].trim();                    
                } else {
                    companyName = splits[1].trim();
                }
                
            }
        }            
    }
    return companyName;
}

const getCompanyLogo = (product: any): string | undefined => {
    if (!product) return undefined;
    const companyName = getCompanyName(product);

    const companiesWithLogo = ['הראל', 'מנורה', 'הפניקס','מגדל','אלטשולר','כלל','אנליסט','מור','אינפיניטי','מיטב דש','ילין לפידות'];

    if (companiesWithLogo.includes(companyName)) {
        return `/logos/${companyName}.png`;
    }    

}


const addCommas = (num: number | undefined) => {
    if (num == undefined)
        return '';

    return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export {
    addCommas, getCompanyLogo, getCompanyName, getProductType
};


